import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["starter","loading", "results", "list"]
  static values = { hub: Number, devicesTypologies: Array, path: String }

  connect() {}

  startScan() {
    this.starterTarget.classList.add("d-none")
    this.loadingTarget.classList.remove("d-none")
    this.resultsTarget.classList.add("d-none")

    setTimeout(() => this.showResults(), 3000)
  }

  // NB: Simulazione dei risultati, in futuro andrà sostituito con i risultati reali
  showResults() {
    this.loadingTarget.classList.add("d-none")
    this.resultsTarget.classList.remove("d-none")

    this.devices = [
      { code: "Vasopresis",
        supported: true,
        devices_typology_id: this.devicesTypologiesValue[0]?.id,
        hub_id: this.hubValue
      },
      { code: "Oximetra",
        supported: true,
        devices_typology_id: this.devicesTypologiesValue[1]?.id,
        hub_id: this.hubValue
      },
      { code: "OxyPulse",
        supported: false,
        devices_typology_id: "",
        hub_id: this.hubValue
      }
    ]

    this.listTarget.innerHTML = ""
    this.devices.forEach(device => {
      this.listTarget.insertAdjacentHTML("beforeend", this.deviceTemplate(device))
    })
  }

  deviceTemplate(device) {
    const typologyOptions = this.devicesTypologiesValue.map(typology => {
      const selected = typology.id === device.devices_typology_id ? 'selected' : ''
      return `<option value='${typology.id}' ${selected}>${typology.name}</option>`
    }).join('')

    return `
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <form class="w-100" data-action="submit->device-scanner#addDevice">
          <div class="row align-items-center">
            <div class="col-12 col-md-4 mb-2 mb-md-0">
              <strong>${device.code}</strong>
            </div>
            <div class="col-8 col-md-4">
              <input type="hidden" name="code" value="${device.code}" />
              <input type="hidden" name="supported" value="${device.supported}" />
              ${device.devices_typology_id == "" ?
                `<select name="devices_typology_id" class="form-select" data-action="change->device-scanner#enableButton">
                  <option value="" disabled selected>Seleziona la tipologia</option>
                  ${typologyOptions}
                </select>`
                :
                `<span class="text-muted">${this.devicesTypologiesValue.find(typology => typology.id === device.devices_typology_id)?.name}</span>
                 <input type="hidden" name="devices_typology_id" value="${device.devices_typology_id}" />`
              }
            </div>
            <div class="col-4 text-start text-md-end">
              ${device.devices_typology_id == "" ?
                `<button type="submit" class="btn btn-link" disabled>Aggiungi</button>`
                :
                `<button type="submit" class="btn btn-link">Aggiungi</button>`
              }
            </div>
          </div>
        </form>
      </li>
    `
  }

  enableButton(event) {
    const select = event.target
    const form = select.closest("form")
    const button = form.querySelector("button[type='submit']")
    if (select.value) {
      button.removeAttribute("disabled")
    }
  }


  // NB: In futuro andrà sostituito con la chiamata reale per la connessione del dispositivo
  async addDevice(event) {
    event.preventDefault()
    if(confirm("Sei sicuro di voler aggiungere questo dispositivo?") === false) {
      return
    }
    const form = event.target
    const code = form.code.value
    const supported = form.supported.value
    const devicesTypologyId = form.devices_typology_id.value

    const token = document.querySelector("meta[name='csrf-token']").content

    setTimeout(async () => {
      const response = await fetch(this.pathValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          device: {
            code: code,
            supported: supported,
            devices_typology_id: devicesTypologyId
          }
        })
      })

      if (response.ok) {
        const data = await response.json()
        window.location.href = data.redirect_url
      } else {
        const data = await response.json()
        alert(data.errors.join(", "))
      }
    }, 1500)
  }
}
